import React from 'react';
import PropTypes from 'prop-types';

export default function ReportIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 15.017 18.07'
      className={className}
    >
      <g id='Grupo_151184' data-name='Grupo 151184' transform='translate(-22.364 -563.317)'>
        <path
          id='Caminho_22036'
          data-name='Caminho 22036'
          d='M532.3,259.8v12.3h5.766v5.766h9.251V259.8Zm3.084,3.084h5.766v1.141h-5.766Zm0,3.084h5.766v1.141h-5.766Zm0,4.225v-1.141h5.766v1.141Zm8.85,4.625h-4.225v-1.141h4.225Zm0-4.625h-1.141v-1.141h1.172v1.141Zm0-3.084h-1.141v-1.141h1.172v1.141Zm0-3.053h-1.141v-1.141h1.172v1.141Z'
          transform='translate(-509.936 303.517)'
          fill={fill}
        />
        <path
          id='Caminho_22037'
          data-name='Caminho 22037'
          d='M537.686,307.786V303.5H533.4Z'
          transform='translate(-510.695 273.292)'
          fill={fill}
        />
      </g>
    </svg>
  );
}

ReportIcon.defaultProps = {
  fill: '#cacaca',
  width: 15.017,
  height: 18.07
};

ReportIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
